import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { BookingsWorkflowsView } from '../../../modules/bookings/bookings-workflows-view'
import '../../../modules/bookings/register-panels'

const searchSchema = z.object({
  panel: z.string().optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

export const Route = createFileRoute('/_authed/bookings/workflows')({
  validateSearch: searchSchema,
  component: WorkflowsRoute,
})

function WorkflowsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <BookingsWorkflowsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
